import Grid from "@material-ui/core/Grid";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import Typography from "@material-ui/core/Typography";
import CustomInput from "../../../../../Components/CustomInput";
import CustomSelect from "../../../../../Components/CustomSelect";
import CrfCoacheeNameInput from "./CrfCoacheeNameInput";

const CrfFormComponent = (props) => {
  const {
    row,
    employeesListForOrg,
    crfStatus,
    getEmployeeDetails,
    handleFormInputChange,
  } = props;

  const prgName = crfStatus.programme_name;
  const isTextArea =
    row.field_type === "text area" || row.field_type === "Text area";
  const isDescription = row.field_name === "description";
  const isTextField = row.field_type === "text" || row.field_type === "Text";
  const isDropdown =
    row.field_type === "dropdown" || row.field_type === "Drop down";

  const validFieldTypes = ["Text", "Drop down", "Text area", "Checkbox"];

  const findIfDisabled = (field_name) => {
    if (field_name === "primary_email") {
      return true;
    }
  };

  const handleTextInput = (changedValue, inputId) => {
    handleFormInputChange(inputId, changedValue);
  };

  const handleDropdownInput = (selectedItemValue, inputId) => {
    handleFormInputChange(selectedItemValue.id, selectedItemValue.value);
  };

  const crfCoacheeNameInputProps = {
    employeesListForOrg,
    row,
    getEmployeeDetails,
  };
  return (
    <Grid
      item
      xs={12}
      container
      direction="row"
      alignItems="flex-start"
      style={{ marginBottom: 20 }}
    >
      <Grid item xs={isDescription ? 10 : isTextArea ? 12 : 5}>
        <Typography variant="h2">{row.field_value}</Typography>
      </Grid>
      <Grid
        item
        style={{
          paddingTop: isTextArea ? "20px" : "",
          //   marginBottom: "20px", If needed more space between the fields uncomment this
        }}
        xs={isTextArea ? 9 : 4}
      >
        {isTextField && row.field_name !== "coahee_name" ? (
          <CustomInput
            defaultValue={row.answer}
            id={row.id}
            variant="outlined"
            placeholder={row.field_value}
            parentcall={handleTextInput}
            value={row.answer}
          />
        ) : null}

        {row.field_name === "coahee_name" && (
          <CrfCoacheeNameInput {...crfCoacheeNameInputProps} />
        )}

        {isTextArea && (
          <CustomInput
            multiline
            rows="4"
            id={row.id}
            InputProps={{
              inputComponent: TextareaAutosize,
            }}
            value={row.answer}
            defaultValue={row.answer}
            variant="outlined"
            parentcall={handleTextInput}
          />
        )}

        {isDropdown &&
          (row.field_name === "programme_name" ? (
            <CustomInput
              disabled
              defaultValue={prgName}
              value={prgName}
              variant="outlined"
            />
          ) : (
            <CustomSelect
              id={row.id}
              displayEmpty
              variant="outlined"
              labelText="Select a value"
              defaultValue={row.answer}
              itemArr={row.option}
              parentcall={handleDropdownInput}
              value={row.answer}
            />
          ))}
      </Grid>
      <Grid item xs={0}></Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};
export default CrfFormComponent;
